import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './offlineStatus.css';
import { isEffectivelyOffline } from '../../utils/helper';

/**
 * Banner shown while the document is being edited offline.
 *
 * Reflects *effective* connectivity, so it also appears when the user chose to
 * work offline from the dashboard. Sync/conflict handling lives elsewhere and
 * is deliberately not part of this component.
 */
function OfflineStatus() {
  const isManualOffline = useSelector((state) => state.slide.isManualOffline);
  const [offline, setOffline] = useState(isEffectivelyOffline());

  useEffect(() => {
    const handleOfflineStatus = () => setOffline(isEffectivelyOffline());

    handleOfflineStatus();
    window.addEventListener('offline', handleOfflineStatus);
    window.addEventListener('online', handleOfflineStatus);

    return () => {
      window.removeEventListener('offline', handleOfflineStatus);
      window.removeEventListener('online', handleOfflineStatus);
    };
  }, [isManualOffline]);

  if (!offline) return null;

  return (
    <div style={{ marginRight: '0%' }}>
      <div className="offlineStatus">
        <h5>
          {isManualOffline
            ? "You're working offline — changes are saved locally on this device."
            : "No internet — you're working offline."}
        </h5>
      </div>
    </div>
  );
}

export default OfflineStatus;
